import React, { useState, useEffect } from 'react';
import Field from '../fields/Field';
import paymentConfig from '../../store/_payment';
import PaymentMethodFormCreditCardTab from './PaymentMethodFormCreditCardTab';
import classnames from 'classnames';
import { getFieldStatusProps } from '../../selectors/defaultSelectors';
import LocalizedMessage from 'react-l10n';
import { getTranslation } from '../../lang/main';

const randKey =
    Math.random()
        .toString(36)
        .substring(2, 15) +
    Math.random()
        .toString(36)
        .substring(2, 15);

function PaymentMethodForm(props) {
    const {
        fieldRefs,
        fieldStatus,
        formData,
        handleFormUpdate,
        updateField,
        disableAssignedSupplierNumber,
        chargeAccountContent,
        autoSelectDefaultPaymentMethod = true,
        showCreditCardFields = true,
    } = props;

    // const [selectedPaymentMethod, setSelectedPaymentMethod] = useState('');
    const selectedPaymentMethod = formData.PaymentMethod;

    const canUseCreditCard =
        typeof props.canUseCreditCard != 'undefined'
            ? props.canUseCreditCard
            : true;
    const canUseBankTransfer =
        typeof props.canUseBankTransfer != 'undefined'
            ? props.canUseBankTransfer
            : true;
    const canUseChargeAccount =
        typeof props.canUseChargeAccount != 'undefined'
            ? props.canUseChargeAccount
            : true;
    const canUsePayFast =
        typeof props.canUsePayFast != 'undefined' ? props.canUsePayFast : true;

    const hasAtLeastOnePaymentMethod =
        canUseCreditCard ||
        canUseBankTransfer ||
        canUseChargeAccount ||
        canUsePayFast;

    const creditCardElementKey = `creditcard-${randKey}`;
    const bankTransferElementKey = `banktransfer-${randKey}`;
    const chargeAccountElementKey = `accountbalance-${randKey}`;
    const payFastElementKey = `payfast-${randKey}`;

    const updatePaymentMethod = (type) => {
        updateField('PaymentMethod', type);
        // setSelectedPaymentMethod(type);
    };

    const setDefaultPaymentMethod = () => {
        if (canUseCreditCard) {
            updatePaymentMethod(paymentConfig.gatewayNames.stripe);
        } else if (canUseBankTransfer) {
            updatePaymentMethod(paymentConfig.gatewayNames.bankTransfer);
        } else if (canUseChargeAccount) {
            updatePaymentMethod(paymentConfig.gatewayNames.accountBalance);
        } else if (canUsePayFast) {
            updatePaymentMethod(paymentConfig.gatewayNames.payfast);
        }
    };

    useEffect(() => {
        if (autoSelectDefaultPaymentMethod) {
            setDefaultPaymentMethod();
        }
    }, [
        props.canUseCreditCard,
        props.canUseBankTransfer,
        props.canUseChargeAccount,
        props.canUsePayFast,
        autoSelectDefaultPaymentMethod,
    ]);

    return (
        <React.Fragment>
            <div id={`payment-${randKey}`} className='payment vspace'>
                {hasAtLeastOnePaymentMethod === false ? (
                    <div className='notice notice--icon notice--alert notice--big'>
                        <i className='icon icon-warning'></i>
                        <p className='heading heading--lv6'>
                            <LocalizedMessage
                                id={'PAYMENT_FORM.PAYMENT_METHOD_WARNING'}
                            />
                        </p>
                    </div>
                ) : (
                    <div className='form payment-form'>
                        <ul className='payment-tabs-nav'>
                            {
                                window.currentOrderPaymentMethod ==
                                    'order-card-authorization-payfast' &&
                                    window.isEditOrder ? (
                                    <li
                                        className={classnames(
                                            'payment-tabs-nav__item active'
                                        )}
                                    >
                                        <a
                                            className='payment-tabs-nav__link'
                                            data-toggle={'tab'}
                                            data-target={`#${payFastElementKey}`}
                                            onClick={() =>
                                                updatePaymentMethod(
                                                    paymentConfig.gatewayNames
                                                        .payfast
                                                )
                                            }
                                        >
                                            <i className='icon icon-saved_cards' />
                                            <span>
                                                <LocalizedMessage
                                                    id={'FIELD.PAYFAST_CREDIT'}
                                                />
                                            </span>
                                        </a>
                                    </li>
                                ) : (
                                    <>
                                        {canUsePayFast === true && (
                                            <li
                                                className={classnames(
                                                    'payment-tabs-nav__item',
                                                    selectedPaymentMethod ===
                                                    paymentConfig.gatewayNames
                                                        .payfast && 'active'
                                                )}
                                            >
                                                <a
                                                    className='payment-tabs-nav__link'
                                                    data-toggle='tab'
                                                    data-target={`#${payFastElementKey}`}
                                                    onClick={() =>
                                                        updatePaymentMethod(
                                                            paymentConfig
                                                                .gatewayNames
                                                                .payfast
                                                        )
                                                    }
                                                >
                                                    <i className='icon icon-saved_cards' />
                                                    <span>
                                                        <LocalizedMessage
                                                            id={'FIELD.PAYFAST_CREDIT'}
                                                        />
                                                    </span>
                                                </a>
                                            </li>
                                        )} 
                                        {canUseCreditCard === true && (
                                            <li
                                                className={classnames(
                                                    'payment-tabs-nav__item',
                                                    selectedPaymentMethod ===
                                                    paymentConfig.gatewayNames
                                                        .stripe && 'active'
                                                )}
                                            >
                                                <a
                                                    className='payment-tabs-nav__link'
                                                    data-toggle='tab'
                                                    data-target={`#${creditCardElementKey}`}
                                                    onClick={() =>
                                                        updatePaymentMethod(
                                                            paymentConfig
                                                                .gatewayNames.stripe
                                                        )
                                                    }
                                                >
                                                    <i className='icon icon-saved_cards' />
                                                    <span>
                                                        <LocalizedMessage
                                                            id={'FIELD.CREDIT_CARD'}
                                                        />
                                                    </span>
                                                </a>
                                            </li>
                                        )}
                                        {canUseBankTransfer === true && (
                                            <li
                                                className={classnames(
                                                    'payment-tabs-nav__item',
                                                    selectedPaymentMethod ===
                                                    paymentConfig.gatewayNames
                                                        .bankTransfer &&
                                                    'active'
                                                )}
                                            >
                                                <a
                                                    className='payment-tabs-nav__link'
                                                    data-toggle='tab'
                                                    data-target={`#${bankTransferElementKey}`}
                                                    onClick={() =>
                                                        updatePaymentMethod(
                                                            paymentConfig
                                                                .gatewayNames
                                                                .bankTransfer
                                                        )
                                                    }
                                                >
                                                    <i className='icon icon-transfer' />
                                                    <span>
                                                        <LocalizedMessage
                                                            id={
                                                                'FIELD.BANK_TRANSFER'
                                                            }
                                                        />
                                                    </span>
                                                </a>
                                            </li>
                                        )}

                                        {canUseChargeAccount === true && (
                                            <li
                                                className={classnames(
                                                    'payment-tabs-nav__item',
                                                    selectedPaymentMethod === paymentConfig.gatewayNames
                                                        .accountBalance && 'active'
                                                )}
                                            >
                                                <a
                                                    className='payment-tabs-nav__link'
                                                    data-toggle='tab'
                                                    data-target={`#${chargeAccountElementKey}`}
                                                    onClick={() =>
                                                        updatePaymentMethod(
                                                            paymentConfig
                                                                .gatewayNames
                                                                .accountBalance
                                                        )
                                                    }
                                                >
                                                    <i className='icon icon-user-details' />
                                                    <span>
                                                        <LocalizedMessage
                                                            id={
                                                                'FIELD.CHARGE_ACCOUNT'
                                                            }
                                                        />
                                                    </span>
                                                </a>
                                            </li>
                                        )}
                                    </>
                                )}
                        </ul>
                        <div
                            id='payment-options'
                            className='tab-content payment-tabs vspace'
                        >
                            {window.localeCountry == 'South Africa' &&
                                window.currentOrderPaymentMethod ==
                                'order-card-authorization-payfast' &&
                                window.isEditOrder ? (
                                <div
                                    id={payFastElementKey}
                                    className={classnames(
                                        'tab-pane payment-tabs__item fade active in'
                                    )}
                                    data-block
                                >
                                    <div className='notice'>
                                        <div className='payment-tabs__content vspace vspace--smaller'>
                                            {
                                                'After clicking Process Payment below you will be redirected to the PayFast website to process payment.'
                                            }
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <>
                                    {canUseCreditCard === true && (
                                        <div
                                            id={creditCardElementKey}
                                            className={classnames(
                                                'tab-pane payment-tabs__item fade',
                                                selectedPaymentMethod ===
                                                paymentConfig.gatewayNames
                                                    .stripe && 'active in'
                                            )}
                                            data-block
                                        >
                                            {props.creditCardContent || ''}
                                            {showCreditCardFields && (
                                                <PaymentMethodFormCreditCardTab
                                                    {...props}
                                                />
                                            )}
                                        </div>
                                    )}
                                    {canUsePayFast === true && (
                                        <div
                                            id={payFastElementKey}
                                            className={classnames(
                                                'tab-pane payment-tabs__item fade',
                                                selectedPaymentMethod ===
                                                paymentConfig.gatewayNames
                                                    .payfast && 'active in'
                                            )}
                                            data-block
                                        >
                                            <div className='notice'>
                                                <div className='payment-tabs__content vspace vspace--smaller'>
                                                    {
                                                        'After clicking Process Payment below you will be redirected to the PayFast website to process payment.'
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    {canUseBankTransfer === true && (
                                        <div
                                            id={bankTransferElementKey}
                                            className={classnames(
                                                'tab-pane payment-tabs__item fade',
                                                selectedPaymentMethod ===
                                                paymentConfig.gatewayNames
                                                    .bankTransfer &&
                                                'active in'
                                            )}
                                            data-block
                                        >
                                            {props.bankTransferContent || ''}
                                        </div>
                                    )}
                                    {canUseChargeAccount === true && (
                                        <div
                                            id={chargeAccountElementKey}
                                            className={classnames(
                                                'tab-pane payment-tabs__item fade',
                                                selectedPaymentMethod ===
                                                paymentConfig.gatewayNames
                                                    .accountBalance &&
                                                'active in'
                                            )}
                                            data-block
                                        >
                                            <div className='notice'>
                                                {chargeAccountContent !=
                                                    null && (
                                                        <div className='payment-tabs__content vspace vspace--smaller'>
                                                            {chargeAccountContent}
                                                        </div>
                                                    )}
                                                <div className='form account-balance-form'>
                                                    <Field
                                                        ref={(r) =>
                                                            (fieldRefs.EXOAccountID = r)
                                                        }
                                                        disabled={
                                                            disableAssignedSupplierNumber ||
                                                            false
                                                        }
                                                        isDisabled={
                                                            disableAssignedSupplierNumber ||
                                                            false
                                                        }
                                                        // required={formData.PaymentMethod == 'accountbalance'}
                                                        label={getTranslation(
                                                            'ACCOUNT_HOLDER_INFORMATION_FORM.CUSTOMER_EXO_ID'
                                                        )}
                                                        animatedLabel={getTranslation(
                                                            'ACCOUNT_HOLDER_INFORMATION_FORM.CUSTOMER_EXO_ID'
                                                        )}
                                                        name='EXOAccountID'
                                                        value={
                                                            formData.EXOAccountID
                                                        }
                                                        onChange={
                                                            handleFormUpdate
                                                        }
                                                        {...getFieldStatusProps(
                                                            fieldStatus,
                                                            'EXOAccountID'
                                                        )}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </React.Fragment>
    );
}

export default PaymentMethodForm;
